<template>
		<div class="header-logo-box">
	    	   <img src="../assets/images/logo.png" class="header-logo">	
			   
			   <el-row>
			     <el-col class="tool" :span="24">
			   	  
			   	  <ul class="toolbar" id="row-bar-group">
			   
			   	            <li :class="{'active': editMode==1&&this.recordTemp.step>1}" v-on:click='back()' class="icon-font">
			   	                <span class="nav-bg-img nav-img-back"></span>
			   	                <span class="icon-text">后退</span>
			   	            </li>
			   	            <li :class="{'active': editMode==1&&this.recordTemp.k>this.recordTemp.step}" v-on:click='forward()' class="icon-font">
			   	                <span class="nav-bg-img nav-img-forword"></span>
			   	                <span class="icon-text">前进</span>
			   	            </li>
			   	       
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div v-on:click='alignerLine()'>	
			   						<span class="nav-bg-img nav-img-alignment"></span>
			   						<span  class="icon-text">对齐</span>
			   					</div>
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div v-on:click='esplitLine()'> 
			   						<span class="nav-bg-img nav-img-split"></span>
			   						<span class="icon-text">拆分</span>
			   					</div>
			   	               
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div v-on:click='mergeLine()'>
			   						<span class="nav-bg-img nav-img-merge"></span>
			   						<span class="icon-text">合并</span>
			   					</div>
			   	           
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div v-on:click='moveUp()'>
			   						<span class="nav-bg-img nav-img-up"></span>
			   						<span class="icon-text">上移</span>
			   					</div>
			   	            </li>
			   	            <li  :class="{'active': editMode==1}" class="icon-font">
			   					<div v-on:click='moveDown()' >
			   					<span class="nav-bg-img nav-img-down"></span>
			   					<span class="icon-text">下移</span>	
			   					</div>
			   	            </li>
			   	            
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div  v-on:click='editorAdd()'>
			   						<span class="nav-bg-img nav-img-insert"></span>
			   						<span class="icon-text">插入</span>
			   					</div>
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div v-on:click='editorDelete()'>
			   						<span class="nav-bg-img nav-img-delete"></span>
			   						<span class="icon-text">删除</span>
			   					</div>
			   	               
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div v-on:click='changeLine()'>
			   						
			   						<span class="nav-bg-img nav-img-swop"></span>
			   						<span class="icon-text">调换</span>
			   					</div>
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div  v-on:click='changeAll()'>
			   					<span class="nav-bg-img nav-img-extract"></span>
			   					<span class="icon-text">全文调换</span>	
			   					</div>
			   
			   	            </li>
			   	     
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div  data-toggle="modal" data-target="#search-modal">
			   						<span class="nav-bg-img nav-img-search"></span>
			   						<span class="icon-text">查找</span>
			   					</div>
			   
			   	            </li>
			   	  
			   	            <li :class="{'active': editMode==1}" class="icon-font" >
			   					<div  v-on:click="repeatFindAll(1)">		
			   						<span class="nav-bg-img nav-img-qc"></span>
			   						<span class="icon-text">同文去重</span>
			   						
			   					</div>
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font" >
			   					<div v-on:click="repeatFindAll(2)">
			   						<span class="nav-bg-img nav-img-qc2"></span>
			   						<span class="icon-text">多译去重</span>
			   					</div>
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div>
			   						<span class="nav-bg-img nav-img-sy"></span>
			   						<span class="icon-text">术语</span>
			   					</div>
			   
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">	
			   					<div v-on:click='countWords()'>
			   						<span class="nav-bg-img nav-img-count"></span>
			   						<span class="icon-text">字数</span>	
			   					</div>
			   
			   	            </li>
			   
			   	            <li :class="{'active': editMode==1}" class="one icon-font">
			   					<div v-on:click='exportFile()'>
			   						<span class="nav-bg-img nav-img-export"></span>
			   						<span class="icon-text">导出</span>	
			   					</div>
			   
			   	            </li>
			   	            <li :class="{'active': editMode==1}" class="one icon-font">
			   					<div v-on:click='saveTmx()'>
			   						<span class="nav-bg-img nav-img-export"></span>
			   						<span class="icon-text">保存</span>
			   					</div>
			   
			   	            </li>
			   				<li :class="{'active': editMode==1}" class="one icon-font">
			   					<div v-on:click='removeAll()()'>
			   						<span class="nav-bg-img nav-img-export"></span>
			   						<span class="icon-text">重置</span>
			   					</div>
			   				
			   				</li>
			   	            <li :class="{'active': editMode==1}" class="icon-font">
			   					<div>
			   						<span class="nav-bg-img nav-img-help"></span>
			   						<span class="icon-text">帮助</span>
			   					</div>
			   
			   	            </li>
			   	       
			   	  
			   	      </ul>
			   	  </el-col>
			   </el-row>
	    </div>
	    
</template>

<script>
	export default {
	  name: 'Header'
	}

</script>

<style>
</style>
